import { getTrinityPlayer, resolveEventName } from './player';
import type { TrinityAudioEventDetail, TrinityAudioEventName, TrinityPlayerGlobal } from './types';

export type ParsedTrinityTtsMessage = {
  detail: TrinityAudioEventDetail;
  trinity: TrinityPlayerGlobal | undefined;
};

export function parseTrinityTtsMessage(event: MessageEvent): ParsedTrinityTtsMessage | null {
  const trinity = getTrinityPlayer();
  const messageType = trinity?.constants?.postMessageType ?? ('TRINITY_TTS' as const);
  if (event.data?.type !== messageType) return null;

  const value = event.data?.value as
    | { action?: string; message?: unknown; playerId?: string }
    | undefined;
  const action = value?.action;
  if (action == null) return null;

  const playerId = value.playerId ?? '';
  const message = value.message;
  const eventName = resolveEventName(action, trinity?.message);

  return {
    trinity,
    detail: {
      event: eventName,
      action,
      playerId,
      message,
    },
  };
}

export function shouldDeliverTrinityEventToConsumer(
  watch: readonly TrinityAudioEventName[] | undefined,
  action: string,
  trinity: TrinityPlayerGlobal | undefined
): boolean {
  if (!watch?.length) return true;

  if (action === 'injectorImp') {
    return watch.includes('injectorImp');
  }

  if (trinity?.message) {
    const allowed = new Set(
      watch
        .filter((n) => n !== 'injectorImp')
        .map((n) => trinity.message![n])
        .filter((v): v is string => Boolean(v))
    );
    return allowed.has(action);
  }

  return false;
}
